import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import "@/App.css";
import { initLenis, scrollToTop } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Admin from "@/components/Admin";
import AuthCallback from "@/components/AuthCallback";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import WorkPage from "@/pages/WorkPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import { Grain, CursorGlow } from "@/components/Shared";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center">
          <p className="max-w-md text-sub">
            Something went wrong while rendering the page. Please refresh.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Layout() {
  useEffect(() => initLenis(), []);
  const location = useLocation();
  useEffect(() => {
    scrollToTop(true);
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-ink text-txt">
      <Grain />
      <CursorGlow />
      <Navbar />
      <div key={location.pathname} className="page-fade">
        <Outlet />
      </div>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Returning from Google OAuth: exchange session_id before anything else renders
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/admin" element={<Admin />} />
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<HomePage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
